import styled from 'styled-components/macro';

export const LogoHolder = styled.div`
  max-width: 70px;
  /* @media (min-width: 768px) {
    max-width: 150px;
  } */
`;
export const Img = styled.img``;
